export default __webpack_public_path__ + "static/media/dragonfruit.ba3676bc.jpeg";